export enum VehiclePoolTab {
  OVERVIEW = 'OVERVIEW',
  ORDERED = 'ORDERED',
  FLOAT_IN = 'FLOAT_IN',
  FLOAT_OUT = 'FLOAT_OUT',
  GHOST_CARS = 'GHOST_CARS',
  MERCHANT_CONSULTATION = 'MERCHANT_CONSULTATION',
  CAR_INCOMING = 'CAR_INCOMING',
  WORKSHOP_APPOINTMENTS = 'WORKSHOP_APPOINTMENTS',
  TUV = 'TUV',
  TYRE_CONDITION = 'TYRE_CONDITION',
  TYRES_SEASON = 'TYRES_SEASON',
  SELL = 'SELL',
  UNHANDLED_DAMAGES = 'UNHANDLED_DAMAGES',
}
